var moment = require('moment');

exports.formatTime = (src, format) => {
    let time = moment(src);
    if (time.isValid()) {
        return time.format(format);
    } else {
        return src;
    }
};

exports.formatIp = (src) => {
    if (src != null) {
        return src.replace("::ffff:", "");
    } else {
        return "";
    }
};

exports.getCookie = (name) => {
    let cookies = document.cookie.split("; ");
    for (let i = 0; i < cookies.length; i++) {
        let item = cookies[i].split("=");
        if (item[0] === name) {
            return item[1];
        }
    }
    return "";
};



// WEBPACK FOOTER //
// ./src/common/utils.js